import React, {Component} from 'react';

// Composants
import Datetime from "react-datetime";
//Style
import "react-datetime/css/react-datetime.css";
import "./YearPicker.css"
//Services

class YearPicker extends Component {

    render() {
        return (
            <div className="year-picker-container">
                <Datetime
                    className="year-picker"
                    dateFormat="YYYY"
                    inputProps={{
                        placeholder: this.props.label,
                        className: 'yearInput'
                    }}
                    value={this.props.value ? this.props.value.toString() : null}
                    name={this.props.name}
                    onChange={this.onChange.bind(this)}/>
                <hr/>
            </div>
        )
    }

    onChange(event) {
        let date = new Date(event._d);
        this.props.onChange(date.getFullYear());
    }

}

export default YearPicker;


// WEBPACK FOOTER //
// ./src/components/yearPicker/YearPicker.js